import React from "react";

const About = () => {
  return (
    <div className="container py-5">
      <h2 className="text-center mb-5">About Me</h2>
      <div className="row">
        <div className="col-xl-6 col-md-6">
          <div className="about-left">
            <p>
              I want to be a successful full-stack developer. I will work hard
              to achieve my goal by learning how to code. . I will learn how to
              code by myself. I want to be an entrepreneur. to achieve this
              goal, I will start freelancing and doing various projects to
              gather my skills.
            </p>
          </div>
          <div className="about-right"></div>
        </div>
      </div>
    </div>
  );
};

export default About;
